var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mb35 p20 brdr-1 brdr-cl-primary bg-cl-white",
      staticStyle: { "border-radius": "30px" }
    },
    [
      _c("div", { staticClass: "row mb15" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
          _c("h3", { staticClass: "m0 mb5" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("My Recently viewed products")) +
                "\n      "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm.items && _vm.items.length > 0
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 p20 brdr-1 brdr-cl-primary bg-cl-white",
                staticStyle: { "border-radius": "30px" }
              },
              [
                _c("product-listing", {
                  attrs: {
                    categoryProps: _vm.categoryProps,
                    columns: "3",
                    products: _vm.items
                  }
                })
              ],
              1
            )
          : _c("div", { staticClass: "col-xs-12 h4" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("No products yet")))])
            ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }